import { differenceInDays } from 'date-fns';
import { getCookie, setCookie } from '@/utils/cookies';
import { BuildCacheSubscriptionRequest, BuildCacheTrial } from '@/models/Account';

const buildCacheTrialNotificationClosedCookieId = 'build_cache_trial_ribbon_closed';
export const dayCountForSecondNagging = 15;
export const dayCountLimitForHighlightedNagging = 3;

export const useShowBuildCacheTrial = ({
  trial,
  subscriptionRequest,
  hasBuildCacheSubscription,
  canActivateBuildCacheSubscription,
}: {
  trial: BuildCacheTrial | null;
  subscriptionRequest: BuildCacheSubscriptionRequest | null;
  hasBuildCacheSubscription: boolean;
  canActivateBuildCacheSubscription: boolean;
}) => {
  const isDayCountLimitForHighlightedNaggingReached = trial
    ? differenceInDays(new Date(trial.expiresAt), new Date()) <= dayCountLimitForHighlightedNagging
    : null;

  const isOnTrialWithSubscriptionRequestAvailable =
    canActivateBuildCacheSubscription &&
    !hasBuildCacheSubscription &&
    !!(trial && !trial.isDeactivated && !subscriptionRequest?.requestedAt);

  const shouldShowBanner =
    isOnTrialWithSubscriptionRequestAvailable &&
    isDayCountLimitForHighlightedNaggingReached &&
    !getCookie(buildCacheTrialNotificationClosedCookieId);

  const shouldShowBuildPerformanceTabNotification =
    isOnTrialWithSubscriptionRequestAvailable && !!getCookie(buildCacheTrialNotificationClosedCookieId);

  const shouldShowBuildCacheInvocationsNotification =
    isOnTrialWithSubscriptionRequestAvailable &&
    !isDayCountLimitForHighlightedNaggingReached &&
    !getCookie(buildCacheTrialNotificationClosedCookieId);

  const onClose = (expires: Date) => {
    setCookie(buildCacheTrialNotificationClosedCookieId, true, {
      cookieOptions: {
        expires,
      },
    });
  };

  return {
    shouldShowBanner,
    shouldShowBuildPerformanceTabNotification,
    shouldShowBuildCacheInvocationsNotification,
    onClose,
  };
};
